import { ChangeDetectorRef, Component, ElementRef, OnInit, Renderer2, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService  } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonWeRequest } from 'src/app/enums/apiRequest';
import {  CouponDetail,SlabdetailServicewise, TransectionResp, WebAppUserProfileResp, WebMemberTypeModel } from 'src/app/enums/apiResponse';
import { RespCode } from 'src/app/enums/emums';
import { ApidataService } from 'src/app/services/apidata.service';
import { ApisessionService } from 'src/app/services/apisession.service';

@Component({
  selector: 'aditya-membershipUpdate',
  templateUrl: './membershipUpdate.component.html',
  styleUrls: ['./membershipUpdate.component.css']
})
export class MembershipUpdateComponent implements OnInit {
  statuscode:number=0;
  msg:string='';
  coupons:CouponDetail[];
  detailsServiceWise:SlabdetailServicewise[];
  webMemberTypeModel:WebMemberTypeModel;
  IsMemberTypeloaded:boolean=false;
  IsMembershipActive:boolean=false;
  IsB2cMembershipRePurchase:boolean=false;
  couponModalView: BsModalRef;
  ServiceModalView: BsModalRef;
  config = {
    keyboard: false,
    class: "modal-lg",
    ignoreBackdropClick: true
  };
  config1 = {
    keyboard: false,
    ignoreBackdropClick: true
  };
  isMobile: boolean
  _ngUnsubscribe$ = new Subject<string>();
  constructor(private apiSession:ApisessionService,private apiData: ApidataService,private modalService: BsModalService, private renderer: Renderer2, private el: ElementRef, private cdr: ChangeDetectorRef) {
  }

  ngOnInit() {
    const myDiv = this.el.nativeElement.querySelector('#myDiv');
    this.apiData.isMobileScreen$.subscribe((value) => {
      this.isMobile = value;
      if (this.isMobile === true) {
        this.renderer.addClass(myDiv, 'mobile-form');
      } else {
        this.renderer.removeClass(myDiv, 'mobile-form');
      }
    })
    this.apiData.isMenuChange$.pipe(takeUntil(this._ngUnsubscribe$)).subscribe((value) => {
      this.isMobile = value
      if (this.isMobile === true) {
       this.updateView()
        this.renderer.removeClass(myDiv, 'mobile-form');
      } else {
        this.renderer.addClass(myDiv, 'mobile-form');
      }
    })
    this.GetMemberShipType();
  }
  GetMemberShipType(){
    debugger;
    
    this.apiSession.GetMembershipType().subscribe((resp:WebMemberTypeModel)=>{
      this.webMemberTypeModel=resp;
      this.IsMemberTypeloaded=true;
     
      this.IsB2cMembershipRePurchase=resp.isB2cMembershipRePurchase;
      
      let _this=this;
      if(resp.memberTypes.length>0){
        resp.memberTypes.filter(x=>{
          if(_this.IsMembershipActive==false && x.isIDActive==true)
          _this.IsMembershipActive=true;
        })
      }
    });
  }
  onClickPurchase(id){
    this.statuscode=0;
    this.msg='';
    var _this=this;
    var reqq:CommonWeRequest={
      ID:id,
      StringID:''
    }
    this.apiSession.PurchaseMemberShip(reqq).subscribe((resp:TransectionResp)=>{
      _this.statuscode=resp.statuscode;
      _this.msg=resp.msg;
      if(_this.statuscode==RespCode.Success){
        _this.GetMemberShipType();
      }
    });
  }
 
  onClickGetCoupons(template: TemplateRef<any>){
    this.statuscode=0;
    this.msg='';
    this.couponModalView = this.modalService.show(template,this.config);
    this.couponModalView.setClass('modal-lg');
    this.GetCoupons();
   
  }
  onClickGetSlabCommission(template: TemplateRef<any>,dsw:SlabdetailServicewise[]){
   
    debugger;
    this.statuscode=0;
    this.msg='';
    this.ServiceModalView = this.modalService.show(template,this.config1);
    this.ServiceModalView.setClass('modal-md');
    this.detailsServiceWise=dsw;
  }

  GetCoupons(){
    var _this=this;
    this.apiSession.GetAllCoupons().subscribe((resp:CouponDetail[])=>{
      _this.coupons=resp;
      if(resp==undefined){
        _this.statuscode=RespCode.Failed;
        _this.msg='No Coupon exists';
      }else if(resp==null){
        _this.statuscode=RespCode.Failed;
        _this.msg='No Coupon exists';
      }if(resp.length==0){
        _this.statuscode=RespCode.Failed;
        _this.msg='No Coupon exists';
      }
    });
  }

  onClickRedeem(couponCode){
    var a="";
    this.statuscode=0;
    this.msg='';
    var _this=this;
    var reqq:CommonWeRequest={
      ID:0,
      StringID:couponCode
    }
    this.apiSession.RedeemCoupon(reqq).subscribe((resp:TransectionResp)=>{
      _this.statuscode=resp.statuscode;
      _this.msg=resp.msg;
      if(_this.statuscode==RespCode.Success){
        _this.GetCoupons();
      }
    });
  }
  updateView() {
    if (!this.cdr['destroyed']) {
      this.cdr.detectChanges();
    }
  }
}
